import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import api from '../../services/api';

export default function StoryReportsManager() {
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('open');
  const [reports, setReports] = useState([]);

  const load = async (nextStatus = status) => {
    try {
      setLoading(true);
      const { data } = await api.get('/story_reports', { params: { status: nextStatus } });
      setReports(Array.isArray(data) ? data : []);
    } catch (err) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudieron cargar los reportes',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load('open');
  }, []);

  const mark = async (id, next) => {
    try {
      await api.put(`/story_reports/${id}`, { status: next });
      setReports((current) => current.filter((item) => item.id !== id));
      toast.current?.show({
        severity: 'success',
        summary: 'Listo',
        detail: next === 'reviewed' ? 'Reporte revisado' : 'Reporte reabierto',
      });
    } catch (err) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo actualizar el reporte',
      });
    }
  };

  return (
    <div className="p-3">
      <Toast ref={toast} />
      <div className="flex align-items-center justify-content-between mb-3">
        <h2 className="m-0">Reportes de historias</h2>
        <div className="flex gap-2">
          <Button
            label="Abiertos"
            outlined={status !== 'open'}
            onClick={() => {
              setStatus('open');
              load('open');
            }}
          />
          <Button
            label="Revisados"
            outlined={status !== 'reviewed'}
            onClick={() => {
              setStatus('reviewed');
              load('reviewed');
            }}
          />
        </div>
      </div>
      {loading ? <p>Cargando…</p> : null}
      {!loading && reports.length === 0 ? <p>No hay reportes.</p> : null}
      <div className="flex flex-column gap-3">
        {reports.map((report) => (
          <Card key={report.id}>
            <div className="flex gap-3">
              {report.storyImageUrl ? (
                <img
                  src={report.storyImageUrl}
                  alt=""
                  style={{ width: 96, height: 144, objectFit: 'cover', borderRadius: 8 }}
                />
              ) : null}
              <div className="flex-1">
                <div className="flex align-items-center gap-2 mb-2">
                  <Tag value={report.status === 'open' ? 'Abierto' : 'Revisado'} />
                  <strong>{report.crossingName || 'Cruce'}</strong>
                  <span>{report.authorName ? `· ${report.authorName}` : ''}</span>
                </div>
                <p className="mt-0 mb-2" style={{ whiteSpace: 'pre-wrap' }}>
                  {report.text}
                </p>
                {report.storyText ? (
                  <p className="mt-0 mb-2 text-color-secondary">Texto de la historia: {report.storyText}</p>
                ) : null}
                <small>
                  Reportó {report.reporterName || 'usuario'}
                  {report.createdAt ? ` · ${new Date(report.createdAt).toLocaleString()}` : ''}
                </small>
                <div className="mt-3">
                  {report.status === 'open' ? (
                    <Button label="Marcar revisado" onClick={() => mark(report.id, 'reviewed')} />
                  ) : (
                    <Button label="Reabrir" outlined onClick={() => mark(report.id, 'open')} />
                  )}
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
